import styled from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme: { token } }) => token.padding}px ${({ theme: { token } }) => token.paddingXL}px;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};

  .map-editor-title {
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
  }

  .action-buttons {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
  }

  .last-updated-info {
    margin-right: ${({ theme: { token } }) => token.marginLG}px;
  }
`;

export default HeaderContainer;
